import ModalArticleHits from "./ModalArticleHits"

export default ModalArticleHits